import React, { JSX, ReactNode } from 'react';
import styles from './GridMenuItem.module.less';

export const GridMenuItem = ({ children }: { children: ReactNode }): JSX.Element => (
  <div className={styles.GridMenuItem}>{children}</div>
);
